module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-five-a.4c5a2357.png";